module.exports = new Promise(function (resolve, reject) {
					var __webpack_error__ = new Error()
					if (typeof window["supplier"] !== 'undefined') return resolve();
					__webpack_require__.l(
						"https://supplier-ui-hnfxcpgparbyhkfw.a03.azurefd.net//remoteEntry.js",
						function (event) {
							if (typeof supplier !== 'undefined') return resolve();
							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
							var realSrc = event && event.target && event.target.src;
							__webpack_error__.message =
								'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
							__webpack_error__.name = 'ScriptExternalLoadError';
							__webpack_error__.type = errorType;
							__webpack_error__.request = realSrc;
							reject(__webpack_error__);
						},
						"supplier",
					);
				}).then(function(){
					var proxy = {
						get: function(request) {
							return Promise.resolve().then(function() { return supplier.get(request); }).then(function(factory) {
								return function() {
									try { return factory(); }
									catch(e) {
										console.warn('remote supplier factory error for ' + request, e);
										return undefined;
									}
								};
							}).catch(function(e) {
								console.warn('remote supplier chunk load failed for ' + request, e);
								return function() { return undefined; };
							});
						},
						init: supplier.init
					}
					return proxy
				}).catch(function(e) {
					console.warn('remote supplier is not available', e);
					let newProxy = {
						get: (module, scope) => () => undefined,
						init: () => {}
					}
					return(newProxy);
				});